<div class="mapCsvColumns map">
  <div class="mapCard map__card">
    <header>
      <h3 class="bk-section-title map__title">Which column holds the phone numbers?</h3>
      <p class="map__sub">
        We picked the likeliest one. The preview marks the column that will be read.
      </p>
    </header>

    <!-- field mapping row -->
    <div class="fieldMapping bk-field map__field">
      <label class="bk-field__label" for="phoneColumn">Phone number column</label>
      <select
        id="phoneColumn"
        class="bk-field__input"
        [(ngModel)]="selectedPhoneColumn"
        (ngModelChange)="updateMapping()"
      >
        @for (header of headers; track header) {
        <option [value]="header">{{ header }}</option>
        }
      </select>
    </div>

    <!-- data preview -->
    @if (previewRows.length) {
    <section class="dataPreview">
      <p class="bk-eyebrow map__eyebrow">
        First {{ previewRows.length }} {{ previewRows.length === 1 ? 'row' : 'rows' }}
      </p>
      <div class="map__scroll">
        <table class="map__table">
          <thead>
            <tr>
              @for (header of headers; track header) {
              <th scope="col" [class.is-picked]="header === selectedPhoneColumn">
                <span class="map__th">
                  {{ header }}
                  @if (header === selectedPhoneColumn) {
                  <span class="bk-sym" aria-hidden="true">check</span>
                  <span class="bk-sr-only">(phone numbers)</span>
                  }
                </span>
              </th>
              }
            </tr>
          </thead>
          <tbody>
            @for (row of previewRows; track $index) {
            <tr>
              @for (header of headers; track header; let i = $index) {
              <td [class.is-picked]="header === selectedPhoneColumn">
                {{ row[i] || '—' }}
              </td>
              }
            </tr>
            }
          </tbody>
        </table>
      </div>
    </section>
    }
  </div>
</div>
